import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const API_BASE_URL = 'https://rudrakshenterprises.liveindiatech.com/rudraksh_backend';

export default function AuthPage({ cartCount, setIsCartOpen, setActiveCategory, setCurrentPage, setSearchQuery }) {
    const [isLogin, setIsLogin] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);

    const handleAuth = async (e) => {
        e.preventDefault();
        setLoading(true);

        const API_BASE_URL = 'https://rudrakshenterprises.liveindiatech.com/rudraksh_backend';
        const endpoint = isLogin ? `${API_BASE_URL}/api/login/` : `${API_BASE_URL}/api/register/`;
        const payload = isLogin ? { email, password } : { name, email, password };

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (response.ok) {
                alert(isLogin ? `Welcome back, ${data.name || 'User'}! Login successful.` : 'Registration successful! Please login.');
                if (isLogin) {
                    if (setCurrentPage) setCurrentPage('home');
                } else {
                    setIsLogin(true); // Sign up ke baad login tab par bhej dein
                }
            } else {
                alert(data.error || 'Authentication failed. Please check your details.');
            }
        } catch (error) {
            console.error('Auth error:', error);
            alert('Server error. Make sure Django backend is running.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col bg-white">
            <Navbar
                cartCount={cartCount}
                setIsCartOpen={setIsCartOpen}
                setActiveCategory={setActiveCategory}
                setCurrentPage={setCurrentPage}
                setSearchQuery={setSearchQuery}
            />

            <main className="flex-1 flex items-center justify-center px-4 py-16 bg-gray-50">
                <div className="max-w-4xl w-full bg-white rounded-3xl shadow-xl overflow-hidden grid grid-cols-1 md:grid-cols-2 border border-gray-100">

                    {/* Left Form Box */}
                    <div className="p-8 sm:p-10 flex flex-col justify-center">
                        <h2 className="text-2xl font-black text-gray-900 mb-2">{isLogin ? 'Login' : 'Sign Up'}</h2>
                        <p className="text-xs text-gray-500 mb-6">{isLogin ? 'Access your account securely' : 'Create a new account to shop easily'}</p>

                        <form onSubmit={handleAuth} className="space-y-4">
                            {!isLogin && (
                                <div>
                                    <label className="block text-xs font-bold text-gray-700 mb-1">Your Name</label>
                                    <input
                                        type="text"
                                        placeholder="Full Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        className="w-full border border-gray-200 rounded-xl p-3 text-xs outline-none bg-gray-50 text-gray-800 focus:ring-2 focus:ring-orange-500"
                                        required
                                    />
                                </div>
                            )}
                            <div>
                                <label className="block text-xs font-bold text-gray-700 mb-1">Your Email</label>
                                <input
                                    type="email"
                                    placeholder="Email Address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full border border-gray-200 rounded-xl p-3 text-xs outline-none bg-gray-50 text-gray-800 focus:ring-2 focus:ring-orange-500"
                                    required
                                />
                            </div>
                            <div>
                                <label className="block text-xs font-bold text-gray-700 mb-1">Password</label>
                                <input
                                    type="password"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full border border-gray-200 rounded-xl p-3 text-xs outline-none bg-gray-50 text-gray-800 focus:ring-2 focus:ring-orange-500"
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full bg-orange-600 hover:bg-orange-700 text-white font-bold py-3 rounded-xl text-xs transition shadow cursor-pointer border-none"
                            >
                                {loading ? 'Processing...' : (isLogin ? 'Login' : 'Register')}
                            </button>
                        </form>

                        <div className="mt-6 text-center">
                            <button
                                onClick={() => setIsLogin(!isLogin)}
                                className="text-xs text-orange-600 font-semibold bg-transparent border-none cursor-pointer hover:underline"
                            >
                                {isLogin ? "Don't have an account? Sign Up" : "I am already a member"}
                            </button>
                        </div>
                    </div>

                    {/* Right Info Box */}
                    <div className="bg-orange-50/50 p-8 flex flex-col items-center justify-center text-center border-l border-gray-100">
                        <h3 className="text-xl font-bold text-gray-900 mb-2">
                            {isLogin ? 'Welcome Back!' : 'Join Our Platform'}
                        </h3>
                        <p className="text-xs text-gray-500 mb-6">
                            Manage your orders, track shipments, and experience seamless wellness shopping.
                        </p>
                        <button
                            onClick={() => setIsLogin(!isLogin)}
                            className="bg-orange-600 text-white px-6 py-2.5 rounded-full text-xs font-bold shadow hover:bg-orange-700 transition border-none cursor-pointer"
                        >
                            {isLogin ? 'Create Account' : 'Continue To Login'}
                        </button>
                    </div>

                </div>
            </main>

            <Footer />
        </div>
    );
}